import styled from 'styled-components';

import { BasicParagraph } from '@genially/design-system';
import { WarningBasicIcon } from '@genially/icons';

export const StyledWarningIcon = styled(WarningBasicIcon)(({ theme: { color } }) => ({
  color: color.content.warning.default(),
}));

export const CloseButton = styled.button(() => ({
  cursor: 'pointer',
}));

export const Wrapper = styled.div(({ theme: { color, borderRadius, size, shadow } }) => ({
  backgroundColor: color.background.warning.default(),
  borderRadius: borderRadius.medium,
  padding: size.units(2),
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
  boxShadow: shadow.short,

  [BasicParagraph]: {
    marginRight: size.units(1),
  },
}));
